import { AxiosInstance } from 'axios'
import { Action, Dispatch } from 'redux'
import { initializePayment } from '../../api/intialize-payment.api'
import { IInitializePayment, IInitializePaymentOption } from '../../models/initialize-payment.model'
import { INITIALIZE_PAYMENT_TYPE } from '../types'
import { INITIALIZE_PAYMENT_RESET } from '../types/initialize-payment.type'

const {
  INITIALIZE_PAYMENT_FAILURE,
  INITIALIZE_PAYMENT_REQUEST,
  INITIALIZE_PAYMENT_SUCCESS,
} = INITIALIZE_PAYMENT_TYPE

const initializePaymentPayload = (initializePaymentData: IInitializePayment) => ({
  type: INITIALIZE_PAYMENT_SUCCESS,
  payload: initializePaymentData,
})

export const initializePaymentAction = (
  axiosInstance: AxiosInstance,
  options: IInitializePaymentOption,
) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: INITIALIZE_PAYMENT_REQUEST })
    return initializePayment(axiosInstance)(options)
      .then((response) => {
        const initializePaymentData = response
        return dispatch(initializePaymentPayload(initializePaymentData))
      })
      .catch((error) => {
        dispatch({
          type: INITIALIZE_PAYMENT_FAILURE,
          payload: error,
        })
      })
  }
}

export const resetInitializePaymentPayLoad = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: INITIALIZE_PAYMENT_RESET,
      payload: {},
    })
  }
}
